"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeAuditEntry = void 0;
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const MAX_ITEM_SIZE_BYTES = 400 * 1024; // 400 KB DynamoDB limit
/**
 * Writes an audit trail entry to DynamoDB and optionally emits an AuditEntryCreated event.
 * This function is non-blocking: if the write fails, it logs an error but does NOT throw.
 */
async function writeAuditEntry(config, input) {
    const { tableName, docClient, publishAuditEvent } = config;
    const { ownerId, userId, action, entityType, entityId, before, after } = input;
    const timestamp = new Date().toISOString();
    const sortKey = `${timestamp}#${entityType}#${entityId}`;
    try {
        // Check serialized size
        const fullItem = {
            ownerId,
            'timestamp#entityType#entityId': sortKey,
            userId,
            action,
            entityType,
            entityId,
            'entityType#timestamp': `${entityType}#${timestamp}`,
            before,
            after,
            timestamp,
        };
        const serialized = JSON.stringify(fullItem);
        const sizeBytes = new TextEncoder().encode(serialized).byteLength;
        let itemToWrite;
        if (sizeBytes > MAX_ITEM_SIZE_BYTES) {
            // Store truncated entry
            console.warn(JSON.stringify({
                level: 'WARN',
                message: 'Audit entry exceeds 400KB, storing truncated entry',
                ownerId,
                entityType,
                entityId,
                actualSize: sizeBytes,
            }));
            itemToWrite = {
                ownerId,
                'timestamp#entityType#entityId': sortKey,
                userId,
                action,
                entityType,
                entityId,
                'entityType#timestamp': `${entityType}#${timestamp}`,
                timestamp,
                truncated: true,
            };
        }
        else {
            itemToWrite = fullItem;
        }
        await docClient.send(new lib_dynamodb_1.PutCommand({ TableName: tableName, Item: itemToWrite }));
        // Emit AuditEntryCreated event (best effort) if publish function provided
        if (publishAuditEvent) {
            try {
                await publishAuditEvent({ ownerId, userId, action, entityType, entityId, timestamp });
            }
            catch (eventError) {
                console.error(JSON.stringify({
                    level: 'ERROR',
                    message: 'Failed to emit AuditEntryCreated event',
                    ownerId,
                    entityType,
                    entityId,
                    error: eventError instanceof Error ? eventError.message : String(eventError),
                }));
            }
        }
    }
    catch (error) {
        // Non-blocking: log error but don't throw
        console.error(JSON.stringify({
            level: 'ERROR',
            message: 'Failed to write audit entry',
            ownerId,
            entityType,
            entityId,
            error: error instanceof Error ? error.message : String(error),
        }));
    }
}
exports.writeAuditEntry = writeAuditEntry;
